<template>
  <v-dialog v-model="localValue" max-width="480" persistent>
    <v-card rounded="lg" class="lfo-card">
      <div class="lfo-header">
        <v-icon size="34" color="white" class="mr-3">mdi-account-alert-outline</v-icon>
        <div>
          <h3 class="white--text mb-0">เข้าสู่ระบบไม่สำเร็จ</h3>
          <p class="white--text caption mb-0 lfo-header-sub">
            {{ groupLabel }}
          </p>
        </div>
        <v-spacer />
        <v-btn icon dark @click="localValue = false"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <v-card-text class="pt-5 pb-4">
        <p class="mb-4">
          ไม่พบชื่อผู้ใช้งานนี้ในระบบ หรือรหัสผ่านไม่ถูกต้อง — เลือกวิธีดำเนินการต่อได้ 2 ทาง
        </p>

        <!-- ทางเลือกที่ 1: ติดต่อ HR -->
        <v-card outlined rounded="lg" class="lfo-option mb-3">
          <v-card-text class="d-flex align-start">
            <v-icon size="30" color="primary" class="mr-3 mt-1">mdi-office-building-marker</v-icon>
            <div>
              <div class="font-weight-bold mb-1">1. ติดต่องานบริหารและพัฒนาทรัพยากรบุคคล</div>
              <div class="caption grey--text text--darken-1">
                ของสถานศึกษาที่ท่านสังกัด เพื่อให้เจ้าหน้าที่ตรวจสอบและรีเซ็ตรหัสผ่านให้โดยตรง
                เหมาะสำหรับกรณีจำเลขบัตรประชาชน/อีเมลที่ลงทะเบียนไว้ไม่ได้
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- ทางเลือกที่ 2: รีเซ็ตด้วยตนเอง (OTP อีเมล) -->
        <v-card outlined rounded="lg" class="lfo-option">
          <v-card-text class="d-flex align-start">
            <v-icon size="30" color="success" class="mr-3 mt-1">mdi-account-key-outline</v-icon>
            <div class="flex-grow-1">
              <div class="font-weight-bold mb-1">2. รีเซ็ตรหัสผ่านด้วยตนเอง</div>
              <div class="caption grey--text text--darken-1 mb-2">
                ยืนยันตัวตนด้วยเลขบัตรประชาชน ชื่อ-นามสกุล และอีเมลที่ลงทะเบียนไว้ในระบบ
                ระบบจะส่งรหัส OTP ไปยังอีเมลนั้นเพื่อตั้งรหัสผ่านใหม่
              </div>
              <reset-password-dialog :person-type="personType" />
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * LoginFailedOptionsDialog.vue — popup ทางเลือกเมื่อเข้าสู่ระบบไม่สำเร็จ (รหัสผ่าน/ชื่อผู้ใช้ผิด)
 * แสดง 2 ทางเลือก: 1) ติดต่องานบุคลากรของสถานศึกษา 2) รีเซ็ตรหัสผ่านด้วยตนเองผ่านระบบ OTP
 * อีเมลที่มีอยู่แล้ว (ResetPasswordDialog.vue) — ไม่ได้เพิ่ม flow ใหม่ แค่ทำให้ผู้ใช้ "เห็น" ทางเลือก
 * ที่มีอยู่แล้วชัดเจนขึ้น ตอนที่ต้องการที่สุดคือทันทีหลังเข้าระบบไม่สำเร็จ (เดิมมีแค่ข้อความ error
 * เฉยๆ ผู้ใช้จำนวนมากจึงโทร/เดินไปหางานบุคลากรของสถานศึกษาทุกครั้งแม้จะ reset เองได้)
 *
 * หมายเหตุ: ยังไม่รวมช่องทางยืนยันตัวตนผ่าน ThaID สำหรับ reset รหัสผ่าน (ตกลงกับผู้ใช้ไว้ว่าจะทำ
 * ภายหลัง หลัง rotate ThaID client secret ที่มีความเสี่ยงรั่วไหลตามที่พบในโค้ดก่อน)
 */
import resetPasswordDialog from "./ResetPasswordDialog.vue";

const GROUP_LABELS = {
  personnel: "ข้าราชการครูและบุคลากรทางการศึกษา / พนักงานราชการ",
  personnel_etc: "ครูอัตราจ้าง / ลูกจ้างประจำ / ลูกจ้างชั่วคราว",
  college: "สถานศึกษา / สถาบัน / สอจ. / ผู้ดูแลระบบ"
};

export default {
  name: "LoginFailedOptionsDialog",
  components: { resetPasswordDialog },
  props: {
    value: { type: Boolean, default: false },
    personType: {
      type: String,
      default: "personnel",
      validator: v => Object.keys(GROUP_LABELS).includes(v)
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    groupLabel() {
      return GROUP_LABELS[this.personType];
    }
  }
};
</script>

<style scoped>
.lfo-header {
  background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  border-radius: 4px 4px 0 0;
}

.lfo-header-sub {
  opacity: 0.85;
}

.lfo-option {
  transition: box-shadow 0.2s ease;
}

.lfo-option:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}
</style>
